shadow$provide[588] = function(global,require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}, php:{enumerable:true, get:function() {
  return php;
}}});
function php() {
  return {extension:[]};
}
const $$default = {php};

};